import { inject } from 'vue';
/**
 * Injection key for site locale data
 */
export const siteLocaleDataSymbol = Symbol(__VUEPRESS_DEV__ ? 'siteLocaleData' : '');
/**
 * Returns the ref of the site data of current locale
 */
export const useSiteLocaleData = () => {
    const siteLocaleData = inject(siteLocaleDataSymbol);
    if (!siteLocaleData) {
        throw new Error('useSiteLocaleData() is called without provider.');
    }
    return siteLocaleData;
};
/**
 * Resolve site data for specific locale
 *
 * It would merge the locales fields to the root fields
 */
export const resolveSiteLocaleData = (site, routeLocale) => ({
    ...site,
    ...site.locales[routeLocale],
});
